<script setup>
import { getCurrentInstance } from 'vue'
import { Head } from '@inertiajs/vue3'
import MainLayout from '@/layout/main/MainLayout.vue'
import Card from 'primevue/card'
import BugForm from './Profile/Partials/BugForm.vue'

defineOptions({
    layout: MainLayout,
})

const { proxy } = getCurrentInstance()
const $t = proxy.$t
</script>

<template>
    <Head :title="$t('Bug Report')" />

    <div class="grid px-4 lg:px-0 w-full max-w-4xl mx-auto">
        <Card id="bug" class="mb-6">
            <template #header>
                <div class="flex items-center gap-3 p-6 pb-0">
                    <i class="pi pi-comment text-2xl text-primary-500"></i>
                    <div>
                        <h2 class="text-xl font-bold text-surface-900">{{ $t('Bug report / Suggestions box') }}</h2>
                        <p class="text-surface-600">{{ $t('Help us improve your experience') }}</p>
                    </div>
                </div>
            </template>

            <template #content>
                <BugForm />
            </template>
        </Card>
    </div>
</template>